export enum BaseKanbanAttachmentsFormFields {
  file = 'file',
}

export type BaseKanbanAttachmentsFormScheme = {
  [BaseKanbanAttachmentsFormFields.file]: File
}
